
import './App.css';
import BeautySalonForm from "./components/BeautySalonForm";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4">
      <BeautySalonForm />
    </div>
  );
}

export default App;
